import Service from '../../services'

// initial state
const state = {
  reservationForm: {
    name: null,
    surname: null,
    tel: null,
    email: null,
  },
}

// getters
const getters = {}

// actions
const actions = {
  async reserveRoom({ commit, state, rootState }, language) {
    const data = await Service.reservation.createReservation({
        ...state.reservationForm,
        room_id: rootState.roomSelected.room.id,
        language
    })
    return data
  },
  clearReservationForm({ commit }) {
    commit('setReservationForm', {
        name: null,
        surname: null,
        tel: null,
        email: null,
    })
  },
}

// mutations
const mutations = {
  setReservationForm(state, form) {
    state.reservationForm = form
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
